import Games from './Games';

export default Games;


// WEBPACK FOOTER //
// ./src/pages/Games/index.js